import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="relative overflow-hidden pt-32 pb-20 md:pt-40 md:pb-32" data-id="element-71">
      <div className="mx-auto max-w-6xl px-6" data-id="element-72">
        <div className="grid gap-12 md:grid-cols-2 md:items-center" data-id="element-73">
          {/* Copy Column */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6
        }} className="flex flex-col gap-6" data-id="element-74">
            <div className="inline-flex items-center rounded-full border border-red-500/30 bg-red-500/10 px-3 py-1 text-xs font-medium text-red-400" data-id="element-75">
              <span className="mr-2 h-2 w-2 animate-pulse rounded-full bg-red-500" data-id="element-76"></span>
              Solo para creadores en crisis
            </div>

            <h1 className="text-5xl font-black leading-[0.9] tracking-tighter text-white md:text-7xl" data-id="element-77">
              Shadowban & Jail <br data-id="element-78" />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-gray-200 to-gray-500" data-id="element-79">
                Survival Kit
              </span>
            </h1>

            <h2 className="text-xl font-bold text-white md:text-2xl" data-id="element-80">
              Sin perder la cabeza
            </h2>

            <p className="text-lg font-medium text-gray-400" data-id="element-81">
              Diagnóstico por síntomas + Plan de 7 días + Plan B
            </p>

            <div className="space-y-4 border-l-2 border-white/10 pl-6 text-gray-300" data-id="element-82">
              <p data-id="element-83">Anoche abriste tu app como siempre.</p>
              <p data-id="element-84">Publicaste. Esperaste. Refrescaste.</p>
              <p data-id="element-85">
                Y el número se quedó ahí… como si tu contenido no existiera.
              </p>
              <p data-id="element-86">
                No es solo "bajas views". Es esa sensación de estar castigado
                sin juicio, sin explicación y con el reloj corriendo porque tus
                ingresos dependen de esto.
              </p>
              <p className="font-semibold text-white" data-id="element-87">
                Este kit no te vende "hacks". Te devuelve algo más raro en 2026:
                control.
              </p>
            </div>

            <div className="mt-4" data-id="element-88">
              <button onClick={() => document.getElementById('pricing')?.scrollIntoView({
              behavior: 'smooth'
            })} className="w-full rounded bg-amber-500 px-8 py-4 text-lg font-bold text-black transition-all hover:bg-amber-400 md:w-auto" data-id="element-89">
                Recuperar el control hoy — $6.36
              </button>
              <p className="mt-3 text-xs text-gray-500" data-id="element-90">
                Para creadores en USA que publican en TikTok/Meta y necesitan
                una respuesta clara.
              </p>
            </div>
          </motion.div>

          {/* Image Column */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative" data-id="element-91">
            <div className="absolute -inset-4 rounded-full bg-amber-500/5 blur-3xl" data-id="element-92"></div>
            <img src="https://cdn.magicpatterns.com/uploads/qfWzEzEaQgKrPGX3wsV2nQ/mockup_sin_perder_la_cabeza.png" alt="Shadowban Survival Kit Mockup" className="relative z-10 w-full rounded-lg shadow-2xl shadow-black/50" data-id="element-93" />
          </motion.div>
        </div>
      </div>
    </section>;
}